import { httpGet } from "../services/apiService";
import Fuse from "fuse.js"

export const panelTerniumModule = {
    state: () => ({
        fetchingPanelTernium: false,
        errorFetchingPanelTernium: false,
        allPanelTernium: [],
        selectedPanelTernium: [],
        fusePanelTernium: [],
        totalPanelTernium: 0,
        totalPesoPanelTernium: 0,
    }),
    mutations: {
        setFetchingPanelTernium(state, newValue) {
            state.fetchingPanelTernium = newValue;
        },
        setErrorFetchingPanelTernium(state, newValue) {
            state.errorFetchingPanelTernium = newValue;
        },
        setAllPanelTernium(state, newValue) {
            state.allPanelTernium = newValue;
        },
        setSelectedPanelTernium(state, newValue) {
            state.selectedPanelTernium = newValue;
        },
        setFusePanelTernium(state, newValue) {
            state.fusePanelTernium = newValue;
        },
        setTotalPanelTernium(state, newValue) {
            state.totalPanelTernium = newValue;
        },
        setTotalPesoPanelTernium(state, newValue) {
            state.totalPesoPanelTernium = newValue;
        },
    },
    actions: {
        async getPanelTernium({ state, commit }) {
            const { data } = await httpGet("/productos?filters[familia][$eq]=panel_ternium&populate=grosores");
            ("Panel Ternium", data?.data);
            commit("setAllPanelTernium", data?.data);
            commit("setFusePanelTernium", new Fuse([...state.allPanelTernium], {
                keys: ["attributes.codigo", "attributes.descripcion"],
            }));
        },
        addPanelTernium({ state, rootState, commit }, newValue) {
            // Flatten product object
            let newEntry = {
                ...newValue.attributes,
                id: newValue.id,
                cantidad: 1,
                largo: 1,
            };

            // Set unit options.
            let unitOptions = [];
            for (const f in newEntry.factores) {
                if (Object.hasOwnProperty.call(newEntry.factores, f)) {
                    const element = newEntry.factores[f];
                    unitOptions.push({ text: element.referencia, value: element });
                }
            }

            newEntry.unit_options = unitOptions.filter(u => u.value.activo == true);
            newEntry.selected_unit = newEntry.unit_options[0].value ?? null;

            // Set discounts
            newEntry.minDiscount = 0;
            newEntry.maxDiscount = 100;
            if (rootState.client?.selectedClient == null) {
                newEntry.descuento_seleccionado = 0;
            }
            else {
                newEntry.descuento_seleccionado = rootState?.client?.selectedClient?.attributes?.descuento_panel_ternium ?? 0;
            }

            let thickness_options = [];
            for (const g of newEntry?.grosores?.data) {
                const option = { text: g.referencia, value: { id: g.id, ...g.attributes } };
                thickness_options.push(option);
            }

            newEntry.thickness_options = thickness_options;
            newEntry.grosor_seleccionado = newEntry.thickness_options[0].value ?? null;

            const valorFlete = resolveValorFlete({
                destiny: rootState?.destinies?.selectedDestiny,
                item: newEntry
            });

            // Set calculated price fields.
            newEntry.precio_provicional_uno = newEntry.precio_lista / newEntry.factores.metro_cuadrado.valor;
            newEntry.precio_provicional_dos = newEntry.precio_provicional_uno * (1 - newEntry.descuento_seleccionado / 100)
            newEntry.flete_provicional = (valorFlete * newEntry.factores.kilogramo.valor) / newEntry.factores.metro_cuadrado.valor;
            newEntry.precio_unitario_final = (newEntry.precio_provicional_dos + newEntry.flete_provicional) * newEntry.largo;
            newEntry.total_local = newEntry.precio_unitario_final * newEntry.cantidad;

            // Set calculated weight fields.
            newEntry.peso_calculado = newEntry.cantidad * (newEntry.selected_unit.peso_por_unidad ?? 0) * newEntry.largo;

            if (newEntry.selected_unit.peso_por_unidad == null) {
                commit("setWarningsPeso", [...rootState.warningsPeso, newEntry]);
            }

            ("new panelternium", newEntry);
            commit("setSelectedPanelTernium", [...state.selectedPanelTernium, newEntry]);
        },
        updatePanelTernium({ state, rootState, commit }, item) {
            const valorFlete = resolveValorFlete({
                destiny: rootState?.destinies?.selectedDestiny,
                item
            });

            if (item.descuento_seleccionado >= item.maxDiscount) {
                item.descuento_seleccionado = item.maxDiscount;
            }
            if (item.descuento_seleccionado <= item.minDiscount) {
                item.descuento_seleccionado = 0;
            }

            // Set calculated price fields.
            item.precio_provicional_uno = item.precio_lista / item.factores.metro_cuadrado.valor;
            item.precio_provicional_dos = item.precio_provicional_uno * (1 - item.descuento_seleccionado / 100)
            item.flete_provicional = (valorFlete * item.factores.kilogramo.valor) / item.factores.metro_cuadrado.valor;
            item.precio_unitario_final = (item.precio_provicional_dos + item.flete_provicional) * item.largo;
            item.total_local = item.precio_unitario_final * item.cantidad;

            // Set calculated weight fields.
            item.peso_calculado = item.cantidad * (item.selected_unit.peso_por_unidad ?? 0) * item.largo;

            commit('setSelectedPanelTernium', [...state.selectedPanelTernium]);
        },
        deletePanelTernium({ state, rootState, commit, dispatch }, product) {
            commit("setSelectedPanelTernium", state.selectedPanelTernium.filter(p => p.id != product.id));
            commit("setWarningsPeso", rootState.warningsPeso.filter(p => p.id != product.id));
        },
        updateAllByDestiny({ state, dispatch }) {
            for (const item of state.selectedPanelTernium) {
                dispatch("updatePanelTernium", item);
            }

            dispatch("updateQuotationTotals");
        }
    }
}

function resolveValorFlete({ destiny, item }) {
    if (destiny == null) {
        // TODO: Err handler
        console.warn("Could not assign VALOR_FLETE. Either destiny or item are does not exist.");
        return;
    }

    if (item?.tipo_panel === "techo") {
        switch (item?.grosor_seleccionado?.grosor) {
            case 1:
                return destiny?.attributes?.fletes_techo?.una;
            case 1.5:
                return destiny?.attributes?.fletes_techo?.una_y_media;
            case 2:
                return destiny?.attributes?.fletes_techo?.dos;
            case 2.5:
                return destiny?.attributes?.fletes_techo?.dos_y_media;
            case 3:
                return destiny?.attributes?.fletes_techo?.tres;
            case 4:
                return destiny?.attributes?.fletes_techo?.cuatro;
            case 5:
                return destiny?.attributes?.fletes_techo?.cinco;
            case 6:
                return destiny?.attributes?.fletes_techo?.seis;
            default:
                this.$toasted.show(`El producto ${item?.descripcion} tiene errores en su configuración. No es posible agregarlo a la cotización.`, { type: "error" })
                throw new Error("No fue posible asignar el valor de flete. Producto no agregado");
        }
    }

    if (item?.tipo_panel === "muro") {
        switch (item?.grosor_seleccionado?.grosor) {
            case 1.5:
                return destiny?.attributes?.fletes_muro?.una_y_media;
            case 2:
                return destiny?.attributes?.fletes_muro?.dos;
            case 2.5:
                return destiny?.attributes?.fletes_muro?.dos_y_media;
            case 3:
                return destiny?.attributes?.fletes_muro?.tres;
            case 4:
                return destiny?.attributes?.fletes_muro?.cuatro;
            case 5:
                return destiny?.attributes?.fletes_muro?.cinco;
            case 6:
                return destiny?.attributes?.fletes_muro?.seis;
            default:
                this.$toasted.show(`El producto ${item?.descripcion} tiene errores en su configuración. No es posible agregarlo a la cotización.`, { type: "error" })
                throw new Error("No fue posible asignar el valor de flete. Producto no agregado");
        }
    }


    throw new Error("No fue posible asignar el valor de flete. Producto no agregado");
}